import axiosInstance from "../Axios";

function getLwfMasters(pageNo = 1, params) {
  try {
    const queryParams = { pageNo };
    if (params && Object.keys(params).length > 0) {
      Object.assign(queryParams, params);
    }

    return axiosInstance.get("/lwf-master", { params: queryParams });
  } catch (error) {
    console.log("Error while fetching LWF master list:", error);
    throw error;
  }
}

function getLwfMasterDetails(id) {
  try {
    return axiosInstance.get(`/lwf-master/${id}`);
  } catch (error) {
    console.log("Error fetching LWF master details:", error);
    throw error;
  }
}

function createLwfMaster(data) {
  try {
    return axiosInstance.post("/lwf-master", data);
  } catch (error) {
    console.log("Error while creating LWF master:", error);
    throw error;
  }
}

function updateLwfMaster(id, data) {
  try {
    return axiosInstance.put(`/lwf-master/${id}`, data);
  } catch (error) {
    console.log("Error while updating LWF master:", error);
    throw error;
  }
}

function deleteLwfMaster(id) {
  try {
    return axiosInstance.delete(`/lwf-master/${id}`);
  } catch (error) {
    console.log("Error while deleting LWF master:", error);
    throw error;
  }
}

// --- Zone API Calls ---
function getZones() {
  try {
    return axiosInstance.get("/compliance/states");
  } catch (error) {
    console.log("Error while fetching state:", error);
    throw error;
  }
}

export {
  getLwfMasters,
  getLwfMasterDetails,
  createLwfMaster,
  updateLwfMaster,
  deleteLwfMaster,
  getZones,
};
